module.exports = __webpack_public_path__ + "img/facebook-logo.77d199c5.png";